// Funzioni per la generazione dei template ( e parti di essi) per la fimra XML

function getSignatureTemplate(
  signedInfo,
  signatureValue,
  CEOcertificate,
  voteToSign
) {
  var template =
    '<?xml version="1.0" encoding="UTF-8"?><Envelope><ds:Signature xmlns:ds="http://www.w3.org/2000/09/xmldsig#" Id="EncryptedBallotSignature">\n' +
    signedInfo +
    '<ds:SignatureValue Id="EncryptedBallotSignatureValue" xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n' +
    signatureValue +
    "\n</ds:SignatureValue>\n" +
    '<ds:KeyInfo xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n' +
    '<ds:X509Data xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n' +
    '<ds:X509Certificate xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n' +
    CEOcertificate +
    "\n</ds:X509Certificate>\n" +
    "</ds:X509Data>\n" +
    "</ds:KeyInfo>\n" +
    voteToSign +
    "\n</ds:Signature></Envelope>";
  return template;
}

function getVoteToSign(encryptedCastVote, encryptedKey, electionId) {
  let voteToSign =
    '<ds:Object xmlns:ds="http://www.w3.org/2000/09/xmldsig#" Id="EncryptedBallot"><xenc:EncryptedData xmlns:xenc="http://www.w3.org/2001/04/xmlenc#" Type="http://www.w3.org/2001/04/xmlenc#Element"><xenc:EncryptionMethod Algorithm="http://www.w3.org/2001/04/xmlenc#aes128-cbc"></xenc:EncryptionMethod><ds:KeyInfo>\n' +
    '<xenc:EncryptedKey><xenc:EncryptionMethod Algorithm="http://www.w3.org/2001/04/xmlenc#rsa-1_5"></xenc:EncryptionMethod><ds:KeyInfo>\n' +
    '<ds:RetrievalMethod Type="RSAKey" URI="' +
    electionId +
    '"></ds:RetrievalMethod>\n' +
    "</ds:KeyInfo><xenc:CipherData><xenc:CipherValue>" +
    encryptedKey +
    "</xenc:CipherValue></xenc:CipherData></xenc:EncryptedKey></ds:KeyInfo><xenc:CipherData><xenc:CipherValue>" +
    encryptedCastVote +
    "</xenc:CipherValue></xenc:CipherData></xenc:EncryptedData></ds:Object>";
  return voteToSign;
}
function getSignedInfo(encodedDigest) {
  let signedInfo =
    '<ds:SignedInfo xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n' +
    '<ds:CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></ds:CanonicalizationMethod>\n' +
    '<ds:SignatureMethod Algorithm="http://www.w3.org/2000/09/xmldsig#rsa-sha1"></ds:SignatureMethod>\n' +
    '<ds:Reference URI="#EncryptedBallot">\n' +
    "<ds:Transforms>\n" +
    '<ds:Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315#WithComments"></ds:Transform>\n' +
    "</ds:Transforms>\n" +
    '<ds:DigestMethod Algorithm="http://www.w3.org/2000/09/xmldsig#sha1"></ds:DigestMethod>\n' +
    "<ds:DigestValue>" +
    encodedDigest +
    "</ds:DigestValue>\n" +
    "</ds:Reference>\n" +
    "</ds:SignedInfo>";
  return signedInfo;
}
function castVoteTemplateBuilder(
  eventIdentifier,
  electionIdentifier,
  candidates,
  affiliations,
  NoChoiceIdentifier,
  NullChoiceIdentifier
) {
  //console.log("[castVoteTemplateBuilder]");

  let castVoteStr = ``;
  castVoteStr =
    '                <ns2:CastVote xmlns="urn:oasis:names:tc:evs:schema:eml" ' +
    'xmlns:ns2="urn:cin:uvote:xmldata:core" ' +
    'xmlns:ns3="urn:oasis:names:tc:ciq:xsdschema:xNL:2.0" ' +
    'xmlns:ns4="urn:oasis:names:tc:ciq:xsdschema:xAL:2.0">' +
    '<EventIdentifier Id="' +
    eventIdentifier.Id +
    '"/>' +
    "<ns2:Election>" +
    '<ElectionIdentifier Id="' +
    electionIdentifier.Id +
    '">' +
    "<ElectionName>" +
    electionIdentifier.ElectionName +
    "</ElectionName>" +
    '<ElectionGroup Id="' +
    electionIdentifier.ElectionGroup.Id +
    '"></ElectionGroup>' +
    "</ElectionIdentifier>" +
    "<ns2:Contest>" +
    '<ContestIdentifier Id="' +
    electionIdentifier.Id +
    '"/>';

  if (candidates.length >= 1) {
    // castVoteStr += "<ns2:CandidateSelection>";
    candidates.forEach(candidate => {
      let ct = candidateTemplateBuilder(candidate.candidate);
      castVoteStr += ct;
    });
    // castVoteStr += "</ns2:CandidateSelection>";
  }
  if (affiliations.length >= 1) {
    affiliations.forEach(affiliation => {
      let at = affiliationTemplateBuilder(affiliation);
      castVoteStr += at;
    });
  }
  if (
    NullChoiceIdentifier &&
    candidates.length < 1 &&
    affiliations.length < 1
  ) {
    let nochoice =
      '<ns2:NullChoiceIdentifier Id="' +
      NullChoiceIdentifier.Id +
      '">' +
      "<ns2:Value>" +
      NullChoiceIdentifier.Value +
      "</ns2:Value></ns2:NullChoiceIdentifier>";
    castVoteStr += nochoice;
  } else if (
    NoChoiceIdentifier &&
    candidates.length < 1 &&
    affiliations.length < 1
  ) {
    let nochoice =
      '<ns2:NoChoiceIdentifier Id="' +
      NoChoiceIdentifier.Id +
      '">' +
      "<ns2:Value>" +
      NoChoiceIdentifier.Value +
      "</ns2:Value></ns2:NoChoiceIdentifier>";
    castVoteStr += nochoice;
  }
  castVoteStr =
    castVoteStr + "</ns2:Contest>" + "</ns2:Election></ns2:CastVote>";

  return castVoteStr;
}
function candidateTemplateBuilder(candidate) {
  let knownAs = "";
  if (candidate.CandidateIdentifier.KnownAs)
    knownAs =
      "<KnownAs>" + candidate.CandidateIdentifier.KnownAs + "</KnownAs>";
  let template =
    '<ns2:Selection><ns2:CandidateSelection><CandidateIdentifier Id="' +
    candidate.CandidateIdentifier.Id +
    '">' +
    "<CandidateName>" +
    candidate.CandidateIdentifier.CandidateName +
    "</CandidateName>" +
    knownAs +
    "</CandidateIdentifier></ns2:CandidateSelection></ns2:Selection>";
  return template;
}
function candidateInAffTemplateBuilder(candidate) {
  let knownAs = "";
  if (candidate.CandidateIdentifier.KnownAs)
    knownAs =
      "<KnownAs>" + candidate.CandidateIdentifier.KnownAs + "</KnownAs>";
  let template =
    '<CandidateIdentifier Id="' +
    candidate.CandidateIdentifier.Id +
    '">' +
    "<CandidateName>" +
    candidate.CandidateIdentifier.CandidateName +
    "</CandidateName>" +
    knownAs +
    "</CandidateIdentifier>";
  return template;
}
function affiliationTemplateBuilder(affiliation) {
  let template =
    "<ns2:Selection>" +
    "<ns2:AffiliationSelection>" +
    '<AffiliationIdentifier Id="' +
    affiliation.id +
    '">' +
    "<RegisteredName>" +
    affiliation.name +
    "</RegisteredName>" +
    "</AffiliationIdentifier>";

  if (affiliation.preferences.length >= 1) {
    affiliation.preferences.forEach(candidate => {
      let cia = candidateInAffTemplateBuilder(candidate.candidate);
      template += cia;
    });
  }

  template += "</ns2:AffiliationSelection>" + "</ns2:Selection>";

  return template;
}
export {
  getSignatureTemplate,
  getVoteToSign,
  getSignedInfo,
  castVoteTemplateBuilder
};
